import { colors } from '../styles';

export const invertObjectForSelect = object => {
  return (Object as any)
    .entries(object)
    .reduce((inverted, [key, value]) => ({ ...inverted, [value]: key }), {});
};

export const colorsForSelect = invertObjectForSelect(colors);

export const iconSizesForSelect = [undefined, 'xs', 'sm', 'md', 'lg', 'xl'];
